<template>
  <Layout>
    <EntitlementPersonLayout />

    <section class="p_main">
      <div class="bg-white rounded box-shadow p-3" v-if="Object.keys(ses).length !== 0">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-lg-12">
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">EP Type</strong>
                  <span v-for="(ep_type, index) in ses.ep_types" :key="index">
                                         - {{ ep_type.ep_type_desc }} <br>
                              </span>
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Household ID</strong>
                  {{ ses.household_number }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <div class="media text-muted">
                  <p class="media-body pb-2 mb-0">
                    <strong class="d-block text-dark pb-1">EP ID</strong>
                    [{{ epModify(ses.ep_id.ep_id) }}]
                  </p>
                </div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">NID</strong>
                  {{ ses.nid }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Name of the EP</strong>
                  {{ ses.name }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Father's Name</strong>
                  {{ ses.father_husband_name }}
                </p>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Mother's Name</strong>
                  {{ ses.mother_name }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Mobile Number</strong>
                  {{ ses.mobile }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Village/Ward</strong>
                  {{ ses.village.village_desc }}
                </p>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Mouza</strong>
                  {{ ses.mouza.mouza_desc }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Union</strong>
                  {{ ses.union.union_desc }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Upazila</strong>
                  {{ ses.upazila.upazila_desc }}
                </p>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">District</strong>
                  {{ ses.district.district_desc }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Division</strong>
                  {{ ses.division.division_desc }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Main Occupation</strong>
                  {{ ses.occupation.occupation_desc }}
                </p>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Religion</strong>
                  {{ ses.religion.religion_desc }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Ethnic(Mention the Group)</strong>
                  {{ ses.ethnic }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Family/Institution Yearly Income</strong>
                  {{ ses.yearly_income }}
                </p>
              </div>
            </div>
            <div class="row pb-2">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Family/Institution Yearly Expenditure</strong>
                  {{ ses.yearly_exp }}
                </p>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <p class="media-body pb-2 mb-0">
                  <strong class="d-block text-dark pb-1">Name of Institution Secretary</strong>
                  {{ ses.institution_sec }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white rounded box-shadow p-3" v-if="Object.keys(ses).length === 0 && !flag">
        <h5 style="text-align: center">No Data Found</h5>
      </div>
    </section>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import EntitlementPersonLayout from './layout'
import http from "@state/http";
import substr_replace from "@views/asset/js/substr_replace";

export default {
  page: {
    title: 'Entitlement Person',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, EntitlementPersonLayout },
  data() {
    return {
      title: 'Entitlement Person Profile',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Entitlement Person Profile',
          active: true,
        },
      ],
      ses: [],
      flag: false
    }
  },
  mounted() {
    this.getEpProfile();
  },

  methods: {
    epModify(ep_id){
      var split_string = ep_id.toString()
      return substr_replace(split_string, '#', 5, 0)
    },
    getEpProfile() {
      let ses_id = this.$route.params.ses_id;
      http.get("api/entitlement-person/personal-information/" + ses_id).then(response => {
        if (!response.error) {
          let data = response.data;
          this.ses = data.ses;
        }
      });
    }
  },
}
</script>

<style scoped>

</style>